import { render, staticRenderFns } from "./main-nav-item.vue?vue&type=template&id=3de1d7ef&scoped=true&lang=pug&"
import script from "./main-nav-item.vue?vue&type=script&lang=coffee&"
export * from "./main-nav-item.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de1d7ef",
  null
  
)

export default component.exports